import { ImageMagickProcessor } from './processors'

export default class RenderQueue {
  constructor (postImageProcessingCompletedCallback, postImageProcessingErrorCallback) {
    this.postImageProcessingCompletedCallback = postImageProcessingCompletedCallback
    this.postImageProcessingErrorCallback = postImageProcessingErrorCallback
    this.availableWorkers = []
    this.queue = []
    this.initializeWorker()
  }

  initializeWorker () {
    const worker = new ImageMagickProcessor(this.onMessage.bind(this), this.onError.bind(this))
    this.availableWorkers.push(worker)
  }

  clear () {
    this.queue = []
  }

  add (job) {
    this.queue.push(job)
    this.dispatch()
  }

  dispatch () {
    const worker = this.availableWorkers.shift()
    if (!worker) return

    const job = this.queue.shift()
    if (!job) {
      this.availableWorkers.push(worker)
      return
    }

    worker.process(job.file, job.counter)
  }

  onError (worker, error) {
    console.error(`An error occurred in a Web Worker. error=${error.message}`)
    this.postImageProcessingErrorCallback(error)
    this.availableWorkers.push(worker)
    this.dispatch()
  }

  onMessage (worker, message) {
    // If it is an error
    const { data, id } = message
    if (data instanceof Error) {
      this.onError(worker, data)
      return
    }

    // If it is a normal message
    this.postImageProcessingCompletedCallback(data, id)
    this.availableWorkers.push(worker)
    this.dispatch()
  }
}
